import React from 'react';
import useAutocomplete from 'components/helpers/hooks/useAutocomplete';
import AutocompleteField from 'components/controls/fields/AutocompleteField';
import FormField from "../form/FormField";

export default function SpecialtiesPicker({value, label, error, onChange, placeholder, ...restProps}) {
    const [specialtiesAutocompleteProps] = useAutocomplete(
        'specialties',
        value,
        (_, v) => onChange({target: {value: v}}),
        {multiple: true},
    );

    return (
        <FormField label={label} error={error}>
            <AutocompleteField
                groupBy={value => loc(value.group)}
                formatter={loc}
                placeholder={placeholder || loc('specialty')}
                {...restProps}
                {...specialtiesAutocompleteProps}
            />
        </FormField>
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/fields/SpecialtiesPicker.jsx